import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-8cc5c730")
const _hoisted_1 = {
  key: 0,
  class: "vocal-modal"
}
const _hoisted_2 = { class: "vocal-delay-item" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "setting-text" }, "人声对齐", -1)
const _hoisted_4 = { class: "delay-container" }
const _hoisted_5 = { class: "delay-tip" }
const _hoisted_6 = { style: {"font-size":"18px","color":"#f38350"} }
const _hoisted_7 = { class: "acc-item" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "setting-text" }, "伴奏音量", -1)
const _hoisted_9 = { class: "acc-item" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "setting-text" }, "人声音量", -1)
const _hoisted_11 = { class: "acc-item" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "stu-setting-text" }, "学生可调节", -1)
_popScopeId()

import { computed, ref, watch } from "vue";
import { VocalBalance } from "../config";
import volumNoTextSlider from "./volumNoTextSlider.vue";
import controlSwitch from "./controlSwitch.vue";

interface VocalBalanceProps {
  visible: boolean;
  vocalBalance: {
    vocal_delay: number; // 人声对齐延迟
    acc_volume: number; // 伴奏音量
    vocal_volume: number; // 人声音量
    device_self_setup: boolean; // 设备是否可自己调节
  };
}


export default _defineComponent({
  props: {
    visible: { type: Boolean, required: true, default: false },
    vocalBalance: { type: Object, required: true, default: () => ({
    vocal_delay: 100,
    acc_volume: 1,
    vocal_volume: 1,
    device_self_setup: false,
  }) }
  } as unknown as undefined,
  emits: ["onChange", "update:visible"] as unknown as undefined,
  setup(__props: {
  visible: boolean;
  vocalBalance: {
    vocal_delay: number; // 人声对齐延迟
    acc_volume: number; // 伴奏音量
    vocal_volume: number; // 人声音量
    device_self_setup: boolean; // 设备是否可自己调节
  };
}, { emit }: { emit: ({
  (event: "onChange", newVal: any): void;
  (event: "update:visible", newVal: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props




const visible = computed<boolean>(() => props.visible);

const vocalBalance = computed<VocalBalance>(() => props.vocalBalance);
// 延迟最小的刻度
const delayCale = 50;
// 学生可调节
const stuCanSet = ref<boolean>(props.vocalBalance.device_self_setup);

const container = ref();
const containerOffset = computed(
  () => container.value?.getBoundingClientRect()?.left
);

watch(
  () => props.vocalBalance.device_self_setup,
  (newVal: boolean) => {
    stuCanSet.value = newVal;
  }
);
// 当前的延迟index
const curDelayIndex = computed<number>(
  () => (vocalBalance.value.vocal_delay + 1000) / (delayCale * 4)
);

const subVocalDelay = () => {
  const newVal = vocalBalance.value.vocal_delay - delayCale;
  if (newVal < -1000) {
    return;
  }
  vocalBalance.value.vocal_delay = newVal;
  emit("onChange", vocalBalance.value);
};

const addVocalDelay = () => {
  const newVal = vocalBalance.value.vocal_delay + delayCale;
  if (newVal > 1000) {
    return;
  }
  vocalBalance.value.vocal_delay = newVal;

  emit("onChange", vocalBalance.value);
};

const handleAccChange = (newVal: number) => {
  vocalBalance.value.acc_volume = newVal;
  emit("onChange", vocalBalance.value);
};

const handleVocalChange = (newVal: number) => {
  vocalBalance.value.vocal_volume = newVal;
  emit("onChange", vocalBalance.value);
};

const handleStuSettingChange = (newVal: boolean) => {
  vocalBalance.value.device_self_setup = newVal;
  emit("onChange", vocalBalance.value);
};

// 点击设置延迟
const handleClickDelay = (event: MouseEvent) => {
  const clientWidth = container.value.clientWidth;
  if (clientWidth === undefined) {
    return;
  }
  const offset = event.pageX - containerOffset.value;
  // 转成具体值
  let delay = (offset / clientWidth) * 2000 - 1000;
  delay = Math.ceil(delay) - (Math.ceil(delay) % 50);
  vocalBalance.value.vocal_delay = delay;
  emit("onChange", vocalBalance.value);
};

return (_ctx: any,_cache: any) => {
  const _component_ArrowLeftBold = _resolveComponent("ArrowLeftBold")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_ArrowRightBold = _resolveComponent("ArrowRightBold")!

  return (_unref(visible))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: "decrease-button",
              onClick: subVocalDelay
            }, [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ArrowLeftBold)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", {
              class: "slider-container",
              ref: container,
              onClick: handleClickDelay
            }, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(11, (val, index) => {
                return _createElementVNode("div", {
                  key: index,
                  class: _normalizeClass(['bar', { active: index === 5 }])
                }, null, 2)
              }), 64)),
              _createElementVNode("div", {
                class: "slider",
                style: _normalizeStyle({
              left: `${((_unref(vocalBalance).vocal_delay + 1000) / 2000) * 100}%`,
            })
              }, null, 4)
            ], 512),
            _createElementVNode("div", {
              class: "increase-button",
              onClick: addVocalDelay
            }, [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ArrowRightBold)
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, " 人声" + _toDisplayString(_unref(vocalBalance).vocal_delay > 0 ? "提前" : "延迟") + _toDisplayString(Math.abs(_unref(vocalBalance).vocal_delay)) + "毫秒 ", 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode(volumNoTextSlider, {
            value: _unref(vocalBalance).acc_volume,
            onOnChange: handleAccChange,
            scale: 2
          }, null, 8, ["value"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createVNode(volumNoTextSlider, {
            value: _unref(vocalBalance).vocal_volume,
            onOnChange: handleVocalChange,
            scale: 4
          }, null, 8, ["value"])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createVNode(controlSwitch, {
            value: _unref(vocalBalance).device_self_setup,
            onOnChange: handleStuSettingChange
          }, null, 8, ["value"])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})